const getSEOTitle = title => {
  const domainParseRegExp = /\/\/([a-z-]+)(\d+)?/gm;
  const [[match, g1, g2]] = Array.from(title.matchAll(domainParseRegExp));
  const domainNameTitle = `${g1.toUpperCase()}${g2 ? `-${g2}` : ''}`;
  return domainNameTitle;
};

export default getSEOTitle;
